module.exports = __webpack_public_path__ + "static/media/evolucao.f80dc5d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Identidade/evolucao.svg
// module id = 279
// module chunks = 0